"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @author Jakub Gereg
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");

var SalesDashboardExcelFileDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SalesDashboardExcelFileDTOConverter, _DataObjectConverter_);

  function SalesDashboardExcelFileDTOConverter() {
    _classCallCheck(this, SalesDashboardExcelFileDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardExcelFileDTOConverter).apply(this, arguments));
  }

  return SalesDashboardExcelFileDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SalesDashboardExcelFileDTOConverter = SalesDashboardExcelFileDTOConverter;